export const storeData = [
  {
    title: "하우스 오브 잭슨카멜레온",
    img_up: "/images/store_up_bg.png",
    title_sub:
      "하우스 오브 잭슨카멜레온은 진정한 집을 찾아가는 것을 넘어 주체적으로 만들어 가는 이들을 위한 공간입니다. ",
    매장주소: "서울 서대문구 연희로 11가길 42 ",
    lat: 37.561923,
    lon: 126.923416,
    전화번호: "1855-2014",
    운영시간: "화-일 11:00 - 19:00",
    img: "/images/연남.png",
    sto_text:
      "전 컬렉션 디스플레이 되어있으나 사이즈, 옵션 등의 차이가 있을 수 있으므로 고객센터를 통하여 확인하신 뒤 방문하시기 바랍니다.",
  },
  {
    title: "현대백화점 판교점",
    img_up: "/images/store_up_bg.png",
    title_sub:
      "새로운 신제품 컬렉션과 베스트 상품까지 다양한 라인업들을 한 곳에서 직접 경험해 볼 수 있는 잭슨카멜레온의 백화점 정식 입점 매장입니다.",
    매장주소: "경기 성남시 분당구 판교역로146번길 20 8층",
    lat: 37.392776,
    lon: 127.111132,
    전화번호: "031-5170-2846",
    운영시간: "월-목 10:30 - 20:00 / 금-일 10:30 - 20:30(백화점 휴무일 참고) ",
    img: "/images/판교.png",
    sto_text:
      "전 컬렉션 디스플레이 되어있으나 사이즈, 옵션 등의 차이가 있을 수 있으므로 고객센터를 통하여 확인하신 뒤 방문하시기 바랍니다.",
  },
  {
    title: "무브먼트랩 한남",
    img_up: "/images/store_down.png",
    title_sub:
      "잭슨카멜레온의 무브먼트랩 에디션 제품과 큐레이션 컬렉션을 다양한 라이프 스타일 브랜드의 소품들과 함께 둘러보고 체험하실 수 있습니다.",
    매장주소: "서울 용산구 대사관로15길 8-3",
    lat: 37.535623,
    lon: 126.994328,
    전화번호: "1644-2709",
    운영시간: "화-일 11:30 - 19:00(월요일 휴무)  ",
    img: "/images/한남.png",
    sto_text: null,
  },
  {
    title: "무브먼트랩 부산",
    img_up: "/images/store_down.png",
    title_sub:
      "해운대 달맞이길에 위치하고 있으며 큐레이션 컬렉션을 다양한 라이프 스타일 브랜드의 소품들과 함께 둘러보고 경험하실 수 있습니다.",
    매장주소: "부산 해운대구 달맞이길65번길 148",
    lat: 35.163453,
    lon: 129.163562,
    전화번호: "1644-2709",
    운영시간: "화-일 11:00 - 19:00 (월요일 휴무)",
    img: "/images/부산.png",
    sto_text: null,
  },
  {
    title: "무브먼트랩 의왕",
    img_up: "/images/store_down.png",
    title_sub:
      "취향이 깃든 공간을 위한 리빙 스타일 큐레이션 스토어로 다양한 브랜드들과 잭슨카멜레온의 제품을 무브먼트랩에서 만날 수 있는 공간입니다.",
    매장주소: "경기 의왕시 백운로 588 지하 1층, 지상 3층  ",
    lat: 37.307602,
    lon: 126.972796,
    전화번호: "1644-2709",
    운영시간: "화-일 11:00 - 19:00 (월요일 휴무)",
    img: "/images/의왕.png",
    sto_text: null,
  },
  {
    title: "무브먼트랩 노량진",
    img_up: "/images/store_down.png",
    title_sub:
      "무브먼트랩의 중고, 리퍼브 제품을 구매하고 무브먼트랩을 통해 구매하셨던 가구를 재판매할 수 있는 세컨드마켓 서비스 매장입니다.",
    매장주소: "서울 동작구 장승배기로18길 3",
    lat: 37.509529,
    lon: 126.941678,
    전화번호: "1644-2709",
    운영시간: " 화 13:00 - 19:00 / 수-일 11:30 - 19:00 (월요일 휴무)",
    img: "/images/노량진.png",
    sto_text: null,
  },
  {
    title: "무브먼트랩 신세계 사우스시티 경기",
    img_up: "/images/store_down.png",
    title_sub:
      "백화점 첫 단독 신세계 사우스시티 매장은 무브먼트랩이 선별한 잭슨카멜레온의 가구와 소품을 경험할 수 있는 리빙  큐레이션 스토어입니다.",
    매장주소: "경기 용인시 수지구 포은대로 536 신세계 사우스시티 6층",
    lat: 37.335465,
    lon: 127.091133,
    전화번호: "1644-2709",
    운영시간: "월-목 10:30 - 20:00 / 금-일 10:30 - 20:30(백화점 휴무일 참고)",
    img: "/images/사우스시티경기.png",
    sto_text: null,
  },
  {
    title: "무브먼트랩 신세계백화점 대전",
    img_up: "/images/store_down.png",
    title_sub:
      "신세계백화점 대전점 지하 1층 생활관에 위치한 무브먼트랩은 다양한 제품들을 자유롭게 경험해보실 수 있는 특별한 공간입니다.",
    매장주소:
      "대전 유성구 엑스포로 1 신세계백화점 대전점 아트앤사이언스 지하1층",
    lat: 36.373056,
    lon: 127.388611,
    전화번호: "1644-2709",
    운영시간: "월-목 10:30 - 20:00 / 금-일 10:30 - 20:30(백화점 휴무 참고)",
    img: "/images/대전.png",
    sto_text: null,
  },
  {
    title: "무브먼트랩 신세계백화점 센텀시티점 부산",
    img_up: "/images/store_down.png",
    title_sub:
      "8층 생활관에 위치한 무브먼트랩 신세계백화점 센텀시티점은 다양한 제품들을 자유롭게 경험해보실 수 있는 특별한 공간입니다. ",
    매장주소: "부산 해운대구 센텀남대로 35 8층 생활관",
    lat: 35.168938,
    lon: 129.130252,
    전화번호: "1644-2709",
    운영시간: "월-목 10:30 - 20:00 / 금-일 10:30 - 20:30(백화점 휴무 참고)",
    img: "/images/센텀시티점부산.png",
    sto_text: null,
  },
  {
    title: "무브먼트랩 현대백화점 더현대 서울",
    img_up: "/images/store_down.png",
    title_sub:
      "4층 Life & Balance 관에 위치한 무브먼트랩 더현대 서울은 다양한 제품들을 자유롭게 경험해보실 수 있는 특별한 공간입니다.",
    매장주소: "서울 영등포구 여의대로 108 더현대 서울 4층 라이프앤밸런스관",
    lat: 37.52526,
    lon: 126.928798,
    전화번호: "1644-2709",
    운영시간: "월-목 10:30 - 20:00 / 금-일 10:30 - 20:30(백화점 휴무 참고)",
    img: "./images/더현대서울.png",
    sto_text: null,
  },
  {
    title: "무브먼트랩 더현대 대구",
    img_up: "/images/store_down.png",
    title_sub:
      "7층 리빙 셀렉션관에 위치한 무브먼트랩 더현대 대구는 다양한 제품들을 자유롭게 경험해보실 수 있는 특별한 공간입니다.",
    매장주소: "대구 중구 달구벌대로 2077 더현대 대구 7층 리빙셀렉션관",
    lat: 35.870728,
    lon: 128.594186,
    전화번호: "1644-2709",
    운영시간: "월-목 10:30 - 20:00 / 금-일 10:30 - 20:30(백화점 휴무 참고)",
    img: "/images/더현대대구.png",
    sto_text: null,
  },
  {
    title: "무브먼트랩 롯데백화점 인천점",
    img_up: "/images/store_down.png",
    title_sub:
      "5층 리빙/가전관에 위치한 무브먼트랩 롯데백화점 인천점은 다양한 제품들을 자유롭게 경험해보실 수 있는 특별한 공간입니다. ",
    매장주소: "인천 미추홀구 연남로 35 5층 리빙/가전관",
    lat: 37.456594,
    lon: 126.703371,
    전화번호: "1644-2709",
    운영시간: "월-목 10:30 - 20:00 / 금-일 10:30 - 20:30(백화점 휴무 참고)",
    img: "/images/롯백인천.png",
    sto_text: null,
  },
];
